if (!customElements.get("switch-tab")) {
  customElements.define(
    "switch-tab",
    class SwitchTip extends HTMLElement {
      constructor() {
        super();
        this.allTabButtons = this.querySelectorAll(".js-tab-button");
        this.allTabContent = this.querySelectorAll(".js-tab-content");

        this.setupEventListeners();
      }
      connectedCallback() {
        this.allTabButtons.forEach((button) => {
          if (button.classList.contains("active")) {
            this.setActiveItem(button);
          }
        });
      }
      setupEventListeners() {
        this.allTabButtons.forEach((button) =>
          button.addEventListener("click", this.handleTabButtonClick.bind(this))
        );
      }
      setActiveItem(activeButton) {
        const activeTab = activeButton.dataset.tab;

        this.allTabButtons.forEach((button) => {
          if (button === activeButton) {
            button.classList.add("active");
            button.setAttribute("aria-expanded", "true");
          } else {
            button.classList.remove("active");
            button.setAttribute("aria-expanded", "false");
          }
        });
        this.allTabContent.forEach((content) => {
          if (content.id === activeTab) {
            content.classList.add("active");
            content.removeAttribute("inert");
          
            setTimeout(
              () => content.firstElementChild.classList.add("active"),
              600
            );
            content.style.maxHeight = `calc(${content.scrollHeight}px)`;
          } else {
            content.classList.remove("active");
            content.firstElementChild.classList.remove("active");
            content.style.maxHeight = `0px`;
            content.setAttribute("inert", '');
          }
        });
      }
      handleTabButtonClick(event) {
        const button = event.target;
        this.setActiveItem(button);
      }
    }
  );
}
